import { createBrowserRouter } from "react-router";
import { Account } from "./routes/account/Account.tsx";
import { ConsoleLayout } from "./routes/console/ConsoleLayout.tsx";
import { Approvals, Crashes, Devices, Feedback, Funnel } from "./routes/console/screens.tsx";
import { Overview } from "./routes/console/Overview.tsx";
import { Releases } from "./routes/console/Releases.tsx";
import { Download } from "./routes/public/Download.tsx";
import { Home } from "./routes/public/Home.tsx";
import { PublicLayout } from "./routes/public/PublicLayout.tsx";
import { SignIn } from "./routes/public/SignIn.tsx";
import { Transparency } from "./routes/public/Transparency.tsx";
import { Problem } from "./routes/Problem.tsx";

export const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    errorElement: <Problem />,
    children: [
      { index: true, element: <Home /> },
      { path: "download", element: <Download /> },
      { path: "signin", element: <SignIn /> },
      { path: "transparency", element: <Transparency /> },
      { path: "account", element: <Account /> },
    ],
  },
  {
    // Behind Cloudflare Access in production; the Worker checks the Access JWT too.
    path: "console",
    element: <ConsoleLayout />,
    errorElement: <Problem />,
    children: [
      { index: true, element: <Overview /> },
      { path: "releases", element: <Releases /> },
      { path: "devices", element: <Devices /> },
      { path: "crashes", element: <Crashes /> },
      { path: "feedback", element: <Feedback /> },
      { path: "funnel", element: <Funnel /> },
      { path: "approvals", element: <Approvals /> },
    ],
  },
]);
